import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router/dist'
import Layout from '~/components/Layout'
import ManagerDetails from './Tabs/ManagerDetails'
import FinancialInfo from './Tabs/FinancialInfo'
import MgaDetails from './Tabs/MGADetails'
import { Label, Tab } from 'semantic-ui-react'
import { RouteTypes } from '~/routes/constants'
import DairyQuery from '~/QueryHooks/DairyQuery'
import { FarmerProfileLogo, StyledDefaultProfile } from '../../Farmers/ShowFarmer/style'
import AssociatedObjects from './Tabs/AssociatedObjects'
import ManagerUsers from './Tabs/ManagerUsers'
import Protocols from './Tabs/Protocols'
import { useSearchParams } from 'react-router-dom'

const filterKeys = ['search', 'agisId', 'membershipStatusId', 'type'] as const

const ShowManager: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab')

  const [activeIndex, setActiveIndex] = useState<string | number>(0)

  const {
    data: showData,
    isLoading: isLoadingData,
    refetch: fetchData
  } = DairyQuery.showManagerData(id)

  const buildCloseUrl = () => {
    const params = new URLSearchParams()
    filterKeys.forEach(key => {
      const value = searchParams.get(key)
      if (value) params.set(key, value)
    })
    const query = params.toString()
    return query ? `${RouteTypes.DAIRY_FACTORY_MANAGERS}?${query}` : RouteTypes.DAIRY_FACTORY_MANAGERS
  }

  const panes = [
    {
      menuItem: t('Manager details'),
      key: 'manager-details',
      render: () => <ManagerDetails />
    },
    {
      menuItem: t('User'),
      key: 'manager-user',
      render: () => <ManagerUsers />
    },
    {
      menuItem: t('Associated objects'),
      key: 'associated-objects',
      render: () => <AssociatedObjects />
    },
    {
      menuItem: t('Financial information'),
      key: 'financial-information',
      render: () => <FinancialInfo />
    },
    {
      menuItem: t('MG-Invoice'),
      key: 'mga-details',
      render: () => <MgaDetails />
    },
    {
      menuItem: t('Protocols'),
      key: 'protocols',
      render: () => <Protocols />
    }
  ]

  useEffect(() => {
    if (tab) {
      const index = panes.findIndex((option) => option.key === tab)
      setActiveIndex(index !== -1 ? index : 0)
    }
  }, [tab])

  useEffect(() => {
    fetchData()
  }, [id, t])

  function renderPanes() {
    return <Tab
      style={{ margin: '30px 0px' }}
      menu={{ secondary: true, pointing: true }}
      onTabChange={(e, data) => {
        const params = Object.fromEntries(searchParams.entries());
        setSearchParams({ ...params, tab: panes[data.activeIndex as number].key }, { replace: true })
        setActiveIndex(data.activeIndex)
      }}
      activeIndex={activeIndex}
      panes={panes}
    />
  }

  function renderDefaultImage() {
    return <StyledDefaultProfile color='blue' name='user circle' size='big' />
  }

  function renderManagerDetails() {
    const agisId = showData?.agisId
    return <FarmerProfileLogo>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className='farmer-logo-container'>
          {renderDefaultImage()}
        </div>
        <div className='farmer-name-container'>
          {agisId && <div className='farmer-supplier'>
            {t('AGIS-ID Person: {{agisId}}', { agisId })}
            <Label className='farmer-abbrevation'>
              {showData?.membershipStatusName}
            </Label>
          </div>}
          <div className='farmer-company-name'>{showData?.name}</div>
        </div>
      </div>
    </FarmerProfileLogo>
  }

  return <Layout
    title={t('Manager details')}
    segmented
    isBusy={isLoadingData}
    close={buildCloseUrl()}
  >
    {renderManagerDetails()}
    {renderPanes()}
  </Layout>
}
export default ShowManager
